import type { ChangeEvent } from 'react'
import { useCallback, useEffect, useState } from 'react'
import { InputVariant, PasswordInput } from '../../inputs'
import { Field } from '../field'
import { useFieldInputAria } from '../hooks'
import type { FieldStatus } from '../types'
import type { PasswordFieldProps } from './types'

const PasswordField = ({ onChange, ...props }: PasswordFieldProps) => {
  const [internalValue, setInternalValue] = useState(props.value)
  const variant = props.error ? InputVariant.critical : InputVariant.neutral
  const handleChange = useCallback(
    (value: ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(value)
      setInternalValue(value.target.value)
    },
    [onChange]
  )

  useEffect(() => {
    setInternalValue(props.value)
  }, [props.value])

  const { 'aria-labelledby': ariaLabelledBy, error, label, helperLabel } = props
  const { fieldElementsIds, fieldInputAriaAttributes } = useFieldInputAria({
    ariaLabelledBy,
    error,
    label,
    helperLabel,
  })

  return (
    <Field
      {...props}
      {...fieldElementsIds}
      counter={internalValue?.length ?? 0}
      status={variant as unknown as FieldStatus}
    >
      <PasswordInput
        {...props}
        {...fieldInputAriaAttributes}
        onChange={handleChange}
        value={internalValue}
        variant={variant}
      />
    </Field>
  )
}
export default PasswordField
